// Shared address elision: `0xXXXX…XXXX` (4 hex head + 4 hex tail).
// Used by Address (variant="elided") and WalletPill. Matches the
// design bundle's chip rendering (`0xe6Cf…d0C4`).
//
// The `_lib/` prefix signals "internal to @rmint/ui — not re-exported
// from index.ts." Callers outside the package compose primitives, not
// helpers.

export function elideAddress(addr: string): string {
  if (addr.length <= 12) return addr;
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}
